import Crud from '../views/PoiType/Crud'
import Entity from '../views/PoiType/Add'

let routes = {
    path: '/poi_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/poi_types/add',
            name: 'NewPoiType',
            component: Entity,
            meta: {
                pageTitle: 'poiType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'poiType.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/poi_types/edit/:id?',
            name: 'EditPoiType',
            component: Entity,
            meta: {
                pageTitle: 'poiType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'poiType.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/poi_types',
            name: 'list-poi-types',
            component: Crud,
            meta: {
                pageTitle: 'poiType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'poiType.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
